export function setButtonURL() {
  if (typeof window.$zopim !== "undefined") {
    window.$zopim(function () {
      window.$zopim.livechat.window.toggle();
    });
  } else if (typeof window.zE !== "undefined") {
    window.zE("webWidget", "toggle");
  } else {
    console.warn("Zendesk Chat not yet loaded.");
  }
}